export type LogFunction = (
  message: string,
  context?: Record<string, any>,
  error?: any | undefined
) => void

export abstract class Logger {
  abstract debug: LogFunction
  abstract error: LogFunction
  abstract info: LogFunction
  abstract warn: LogFunction
}
